import IndexTracker from './tracker/index_tracker';
import ShippingCostTracker from './tracker/shipping_cost_tracker';
import CheckoutTracker from './tracker/checkout_tracker';
import AlternativeOrderTracker from './tracker/alternative_order_tracker';
import PostcodeTracker from './tracker/postcode_tracker';
import FittingStationTracker from './tracker/fitting_station_tracker';
import AutoSuggestTracker from './tracker/auto_suggest_tracker';
import RecommendationTracker from './tracker/recommendation_tracker';
import ProductRecommendationTracker from './tracker/product/product_recommendation_tracker';
import FooterTracker from './tracker/footer_tracker';
import VehicleSelectorTracker from './tracker/vehicle_selector_tracker';
import CatalogFacetTracker from './tracker/catalog/facet_tracker';
import CatalogPromotionTracker from './tracker/catalog/promotion_tracker';
import IndexPromotionTracker from './tracker/index/promotion_tracker';
import EnhancedEcommerceTracker from './tracker/enhanced_ecommerce';

/**
 * @param {TrackingAnalytics} analytics
 */
function TrackingManager(analytics) {
    'use strict';
    this.analytics = analytics;
    this.trackerFactory = this.getTrackerFactory();
    this.trackers = {};
}

TrackingManager.prototype = {

    init: function () {
        'use strict';
        this.analytics.init();
        this.initTrackers();
    },

    /**
     * @return {TrackingManager}
     */
    initTrackers: function () {
        'use strict';
        for (var i in this.trackers) {
            if (this.trackers.hasOwnProperty(i)) {
                this.trackers[i].init();
            }
        }
        return this;
    },

    /**
     * @param  {String} trackerType
     * @return {TrackingManager}
     */
    registerTracker: function (trackerType) {
        'use strict';
        var tracker;

        if (this.trackerFactory.hasOwnProperty(trackerType)) {

            tracker = new this.trackerFactory[trackerType](this.analytics);

            this.trackers[trackerType] = tracker;
        }

        return this;
    },

    /**
     * @param  {Array} trackerTypes
     * @return {TrackingManager}
     */
    registerTrackers: function (trackerTypes) {
        'use strict';

        for (var i = 0; i < trackerTypes.length; i++) {
            this.registerTracker(trackerTypes[i]);
        }

        return this;
    },

    /**
     * @todo Perhaps provide this externally once it grows
     * @return {Object}
     */
    getTrackerFactory: function () {
        'use strict';

        return {
            'IndexTracker': IndexTracker,
            'ShippingCostTracker': ShippingCostTracker,
            'CheckoutTracker': CheckoutTracker,
            'FittingStationTracker': FittingStationTracker,
            'AutoSuggestTracker': AutoSuggestTracker,
            'RecommendationTracker': RecommendationTracker,
            'AlternativeOrderTracker': AlternativeOrderTracker,
            'ProductRecommendationTracker': ProductRecommendationTracker,
            'FooterTracker': FooterTracker,
            'VehicleSelectorTracker': VehicleSelectorTracker,
            'CatalogFacetTracker': CatalogFacetTracker,
            'CatalogPromotionTracker': CatalogPromotionTracker,
            'PostcodeTracker': PostcodeTracker,
            'IndexPromotionTracker': IndexPromotionTracker,
            'EnhancedEcommerceTracker': EnhancedEcommerceTracker
        };
    }
};

export default TrackingManager;